import { motion } from "framer-motion";
import { ChoiceButton } from "./ChoiceButton";

const KICKER_STYLES = {
  cyan: "border-cyan-400 text-cyan-600 shadow-[0_0_12px_rgba(6,182,212,0.25)]",
  pink: "border-pink-500 text-pink-600 shadow-[0_0_12px_rgba(236,72,153,0.25)]",
  yellow: "border-yellow-400 text-yellow-600 shadow-[0_0_12px_rgba(234,179,8,0.25)]",
};

export const QuestionScreen = ({ step, stepNumber, totalSteps, value, onAnswer }) => (
  <div data-testid="survey-card" className="relative flex-1 flex flex-col justify-center px-6 py-10">
    <span
      aria-hidden="true"
      className="ghost-number pointer-events-none select-none absolute -top-2 right-2 text-[9rem] font-black leading-none"
    >
      {String(stepNumber).padStart(2, "0")}
    </span>

    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.05 }}>
      <span
        data-testid="question-kicker"
        className={`inline-block rounded-full border bg-white px-3.5 py-1.5 font-display text-[10px] font-extrabold uppercase tracking-[0.18em] ${KICKER_STYLES[step.accent]}`}
      >
        {step.kicker}
      </span>
      <p className="mt-4 font-display text-[11px] font-extrabold tracking-[0.25em] text-slate-300">
        {String(stepNumber).padStart(2, "0")} / {String(totalSteps).padStart(2, "0")}
      </p>
    </motion.div>

    <motion.h2
      data-testid="question-title"
      className="font-display mt-2 text-3xl sm:text-4xl font-black tracking-tight text-slate-900"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1, type: "spring", stiffness: 200, damping: 22 }}
    >
      {step.title}
    </motion.h2>

    {step.tagline && (
      <motion.p
        className="mt-2 font-display text-base font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.16 }}
      >
        {step.tagline}
      </motion.p>
    )}

    <motion.p
      data-testid="question-text"
      className="mt-3 text-base sm:text-lg leading-relaxed text-slate-600"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
    >
      {step.text}
    </motion.p>

    <div className="mt-9 flex flex-col gap-4">
      {step.choices.map((choice, i) => (
        <ChoiceButton
          key={choice}
          label={choice}
          index={i}
          selected={value === choice}
          onClick={() => onAnswer(choice)}
        />
      ))}
    </div>
  </div>
);
